import { render, staticRenderFns } from "./ProductsAndBundles.vue?vue&type=template&id=145f9e8b&"
import script from "./ProductsAndBundles.ts?vue&type=script&lang=js&"
export * from "./ProductsAndBundles.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports